import React, { useState } from 'react';
import './NewsletterPopup.css';

interface NewsletterPopupProps {
  isVisible: boolean;
  onClose: () => void;
}

const NewsletterPopup: React.FC<NewsletterPopupProps> = ({ isVisible, onClose }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsLoading(true);
    
    // Simulate API call - replace with your actual newsletter signup endpoint
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    setIsLoading(false);
    setIsSuccess(true);
    
    // Close popup after 2 seconds
    setTimeout(() => {
      onClose();
    }, 2000);
  };

  const handleClose = () => {
    // Mark as shown in localStorage
    localStorage.setItem('nrtr-newsletter-shown', 'true');
    onClose();
  };

  if (!isVisible) return null;

  return (
    <div className="newsletter-overlay" onClick={handleClose}>
      <div className="newsletter-popup" onClick={(e) => e.stopPropagation()}>
        <button className="newsletter-close" onClick={handleClose} aria-label="Close popup">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
        
        <div className="newsletter-content">
          {!isSuccess ? (
            <>
              <div className="newsletter-header">
                <div className="newsletter-logo">
                  <img src="/nrtr-logo-circle.png" alt="NRTR" />
                </div>
                <h2 className="newsletter-title">Stay Connected with NRTR</h2>
                <p className="newsletter-subtitle">
                  Get the latest updates, tips, and insights delivered to your inbox. 
                  Join our community of network professionals.
                </p>
              </div>

              <form className="newsletter-form" onSubmit={handleSubmit}>
                <div className="newsletter-input-group">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    className="newsletter-input"
                    required
                    disabled={isLoading}
                  />
                  <button 
                    type="submit" 
                    className="newsletter-button"
                    disabled={isLoading || !email}
                  >
                    {isLoading ? (
                      <span className="newsletter-spinner"></span>
                    ) : (
                      'Subscribe Now'
                    )}
                  </button>
                </div>
                
                <p className="newsletter-privacy">
                  We respect your privacy. Unsubscribe at any time.
                </p>
              </form>
            </>
          ) : (
            <div className="newsletter-success">
              <div className="newsletter-success-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <circle cx="24" cy="24" r="24" fill="#1DB584"/>
                  <path d="M20 24L22 26L28 20" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="newsletter-success-title">Welcome to NRTR!</h3>
              <p className="newsletter-success-text">
                Thank you for subscribing. You'll receive our latest updates and insights soon.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsletterPopup; 